import PropTypes from "prop-types";

import { ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import { Loader } from "@vds/loaders";
import { useDispatch, useSelector } from "react-redux";
import { createRequest, updateRequest } from "../../../store/actions/asset";

function AssetReview(props) {
  const { opHeaderText, formData, onExit } = props;
  const dispatch = useDispatch();

  const handleAdd = () => {
    if(opHeaderText === "Add" && !formData.isSubmitted){
      dispatch(createRequest());
    }

    if(opHeaderText === "Edit" && !formData.isSubmitted){
      dispatch(updateRequest());
    }
  };
  
  return (
    <>
      <ModalTitle>
        <Body size="large">{opHeaderText} asset</Body>
        <div className="mt-2">
          <Title size="large" bold={true}>
            Review asset
          </Title>
        </div>
      </ModalTitle>
      <ModalBody>
        <div className="d-flex flex-column justify-content-center align-items-start w-100">
          <Title size="small" bold={true} color="#6F7171">
            Asset details
          </Title>
          <div className="w-100 d-flex justify-content-start align-items-start pt-2">
            <div className="w-33 d-flex flex-column justify-content-start align-items-start ats-word-break">
              <Body size="large" bold={true}>
                Asset name
              </Body>
              <Body size="large" bold={false}>
                {formData?.step1?.assetName}
              </Body>
            </div>

            <div className="w-33 d-flex flex-column justify-content-start align-items-start ats-word-break">
              <Body size="large" bold={true}>
                Description
              </Body>
              <Body size="large" bold={false}>
                {formData?.step1?.description || "N/A"}
              </Body>
            </div>
          </div>
        </div>

        <div className="d-flex flex-column justify-content-center align-items-start w-100 mt-4">
          <Title size="small" bold={true} color="#6F7171">
            Device details
          </Title>
          <div className="w-100 d-flex justify-content-start align-items-start pt-2">
            <div className="w-33 d-flex flex-column justify-content-start align-items-start ats-word-break">
              <Body size="large" bold={true}>
                Device model
              </Body>
              <Body size="large" bold={false}>
                {formData?.step2?.deviceType || "N/A"}
              </Body>
            </div>

            <div className="w-33 d-flex flex-column justify-content-start align-items-start ats-word-break">
              <Body size="large" bold={true}>
                Device ID
              </Body>
              <Body size="large" bold={false}>
                {formData?.step2?.deviceId?.name || "N/A"}
              </Body>
            </div>

            <div className="w-33 d-flex flex-column justify-content-start align-items-start ats-word-break">
              <Body size="large" bold={true}>
                Device Profile
              </Body>
              <Body size="large" bold={false}>
                {formData?.step2?.deviceProfile?.name || "N/A"}
              </Body>
            </div>
          </div>
        </div>

        <div className="d-flex flex-column justify-content-center align-items-start w-100 mt-4">
          <Title size="small" bold={true} color="#6F7171">
            Additional details
          </Title>
          <div className="w-100 d-flex justify-content-start align-items-start pt-2">
            <div className="w-33 d-flex flex-column justify-content-start align-items-start ats-word-break">
              <Body size="large" bold={true}>
                Location zone
              </Body>
              <Body size="large" bold={false}>
                {formData?.step3?.locationZone || "N/A"}
              </Body>
            </div>

            <div className="w-33 d-flex flex-column justify-content-start align-items-start ats-word-break">
              <Body size="large" bold={true}>
                Asset type
              </Body>
              <Body size="large" bold={false}>
                {formData?.step3?.assetType || "N/A"}
              </Body>
            </div>

            <div className="w-33 d-flex flex-column justify-content-start align-items-start ats-word-break">
              <Body size="large" bold={true}>
                Asset model
              </Body>
              <Body size="large" bold={false}>
                {formData?.step3?.assetModel || "N/A"}
              </Body>
            </div>
          </div>
          <div className="w-100 d-flex justify-content-start align-items-start pt-2 mt-4">
            <div className="w-33 d-flex flex-column justify-content-start align-items-start ats-word-break">
              <Body size="large" bold={true}>
                Asset serial number
              </Body>
              <Body size="large" bold={false}>
                {formData?.step3?.assetSerialNumber || "N/A"}
              </Body>
            </div>

            <div className="w-33 d-flex flex-column justify-content-start align-items-start ats-word-break">
              <Body size="large" bold={true}>
                Asset owner
              </Body>
              <Body size="large" bold={false}>
                {formData?.step3?.assetOwner || "N/A"}
              </Body>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter
        buttonData={{
          close: {
            disabled: formData.isSubmitted,
            width: "100%",
            children: formData.isSubmitted ? <div style={{height: "24px"}}><Loader fullscreen={false} active={true} surface="light"/></div> : (opHeaderText === "Edit" ? "Save" : "Add"),
            onClick: handleAdd,
          },
          primary: {
            children: "Back",
            width: "100%",
            onClick: onExit,
          },
        }}
      />
    </>
  );
}

AssetReview.propTypes = {
  formData: PropTypes.object.isRequired,
  onExit: PropTypes.func.isRequired,
};

export default AssetReview;
